import {AbsoluteFill} from 'remotion';

export const HugeImage: React.FC = () => {
	return (
		<AbsoluteFill
			style={{
				backgroundColor: 'red',
			}}
		/>
	);
};
